var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5313 11.3125L12.0313 9.8125C11.9375 9.78125 11.8438 9.75 11.7188 9.75C11.5 9.75 11.2813 9.875 11.1563 10.0312L9.59375 11.9375C7.15625 10.7813 5.21875 8.84375 4.0625 6.40625L5.96875 4.84375C6.125 4.71875 6.25 4.5 6.25 4.25C6.25 4.15625 6.21875 4.0625 6.1875 3.96875L4.6875 0.46875C4.5625 0.1875 4.28125 0 3.96875 0C3.9375 0 3.875 0.03125 3.8125 0.03125L0.5625 0.78125C0.21875 0.875 0 1.15625 0 1.5C0 9.53125 6.46875 16 14.5 16C14.8438 16 15.125 15.7813 15.2188 15.4375L15.9688 12.1875C15.9688 12.125 15.9688 12.0625 15.9688 12.0313C15.9688 11.7188 15.7813 11.4375 15.5313 11.3125Z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ef8e54f3dd2277d0e79dedb3c4ad76c4.svg";
export { ForwardRef as ReactComponent };